import withDirectionDetail from "../withDirectionDetail";
import DirectionBloodForm from "./DirectionBloodForm";
import DirectionBloodPDFGenerator from "./DirectionBloodPDFGenerator";

const directionFormKazakhName = 'Қанды вирустық гепатиттердің маркерлеріне зерттеуге ЖОЛДАМА'
const directionFormName = 'НАПРАВЛЕНИЕ на исследование крови на маркеры вирусных гепатитов'
const directionFormNumber = '015'
const directionName = 'DirectionBlood'

export default withDirectionDetail(DirectionBloodForm, DirectionBloodPDFGenerator, directionFormKazakhName,  directionFormName,  directionFormNumber, directionName)